import TextArea from "antd/lib/input/TextArea";
import { useContext, useEffect, useRef, useState } from "react";
import { SpinContext } from "../../../../../component/Spin/spin.context";
import { spinActions } from "../../../../../component/Spin/spin.reducer";
import { MComment } from "../../../product/entity/product.model";
import CComment from "../../../product/screen/component/CComment";
import { taskService } from "../../service/task.service";

export interface AssignmentCommentsProps {
  assignmentUuid?: string;
}

function AssignmentComments(props: AssignmentCommentsProps) {
  const [text, setText] = useState<string>();
  const [comments, setComments] = useState<MComment[]>([]);
  const messagesEnd = useRef<HTMLDivElement>(null);

  const { dispatch } = useContext(SpinContext);

  useEffect(() => {
    if (props.assignmentUuid) {
      getComments(props.assignmentUuid);
    }

    return () => {
      setComments([]);
    };
  }, [props.assignmentUuid]);

  const getComments = (assignmentUuid: string) => {
    dispatch({ type: spinActions.BLOCK });

    taskService
      .getAssignmentComments(assignmentUuid)
      .then((comments: MComment[]) => {
        setComments(comments);

        messagesEnd.current?.scrollIntoView();
      })
      .finally(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });
  };

  const addComment = () => {
    if (text && props.assignmentUuid) {
      taskService
        .addAssignmentComment({
          content: text,
          assignmentUuid: props.assignmentUuid,
        })
        .then((x) => {
          getComments(props.assignmentUuid!);
          setText(undefined);
        });
    }
  };

  return (
    <div className="card">
      <div className="card-header header-elements-inline">
        <h5 className="card-title">Сэтгэгдлүүд</h5>
      </div>
      <div className="card-body">
        <div
          style={{
            maxHeight: "400px",
            overflowY: "scroll",
          }}
        >
          {comments.length > 0 ? (
            comments.map((e, i) => <CComment key={e.uuid} comment={e} />)
          ) : (
            <div className="media text-muted">Сэтгэгдэл олдсонгүй.</div>
          )}
          <div style={{ float: "left", clear: "both" }} ref={messagesEnd}></div>
        </div>
        <TextArea
          value={text}
          rows={5}
          className="my-3"
          onChange={(e) => setText(e.target.value)}
        />
        <div className="text-right">
          <button
            type="button"
            className="btn bg-blue"
            onClick={addComment}
            disabled={!props.assignmentUuid}
          >
            <i className="icon-plus22 mr-1" /> Сэтгэгдэл үлдээх
          </button>
        </div>
      </div>
    </div>
  );
}

export default AssignmentComments;
